import {MatTable, MatTableDataSource} from '@angular/material/table';
import {AfterViewInit, Component, ElementRef, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {ArmaServConnection} from 'src/app/classes/info-connection';
import {HttpClient} from '@angular/common/http';
import {CLineDec, GradeManager} from 'src/app/classes/decorticage/info-decorticage';
import {ArmaDate, CUtilit} from 'src/app/classes/utilit';
import {MatDialog} from '@angular/material/dialog';
import {MatMenuTrigger} from '@angular/material/menu';
import {CUtilForme, IInputCotation} from 'src/app/classes/info-forme';
import {
  ArmaRestContact, ErrorLineDec, FavoriteShape, FavoriteShapeStatus, Formes, Grade, JsLineDec,
  LoadedAnalysis, SteelListValidity
} from 'src/app/classes/json-interface';
import {AppToolbarService} from '../toolbar/services/app-toolbar.service';
import {ArmaShapeUtilit} from '../arma-shape/arma-shape.component';
import {DialogShape99} from '../dialog/dialogShape99/dialogShape99';
import {DialogProductInput} from '../dialog/dialogProductInput/dialogProductInput';
import {MatExpansionPanel} from '@angular/material/expansion';
import {SiteSelectorComponent} from '../site-selector/site-selector.component';
import {g_params} from 'src/app/classes/global-param';
import {MatDrawer} from '@angular/material/sidenav';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TranslateService} from '@ngx-translate/core';
import {CProduct} from 'src/app/classes/decorticage/info-product';
import {ArmaDateTimePickerComponent} from '../arma-date-time-picker/arma-date-time-picker.component';
import {BackupDec, BackupDecInterface} from 'src/app/classes/decorticage/backup-dec';
import {DialogErreurLineDecComponent} from '../dialog/dialogErreurLineDec/dialogErreurLineDec.component';
import {UtilitAnalysis} from 'src/app/classes/decorticage/Utilits-analysis';
import {DialogSpecialMesh} from '../dialog/dialogSpecialMesh/dialogSpecialMesh';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {ArmaServServerMethods} from '../../classes/ArmaServServerMethods';
import {DialogListContactComponent} from '../dialog/dialogListContact/dialog-list-contact-component';
import {DialogOrderNoteComponent} from '../dialog/dialog-order-note/dialog-order-note.component';
import {WMeshUtils} from '../../classes/mesh-utils';

// TODO reactiver le tslint triple-equals apres avoir tester les triple equal
// TODO reactiver le tslint no-string-throw

interface AnalysisFile {
  fileName: string;
  isSend: boolean;
  inProgress: boolean;
  file?: File;
}

/** Information de l'entete du tableau de décorticage */
export interface OrderInfo {
  Designation: string;
  NumPlan: string;
  Various: string;
  SiteCode?: string; /* Utiliser seulement pour le get */
  CustomerRef: string;
  UnixDateDelivery: number|undefined;
  IdContact: number|undefined;
  UnixDateCreate: number;
  Note: string;
}

const LOCAL_STORAGE_ORDER_PANEL_STATE = 'LOCAL_STORAGE_ORDER_PANEL_STATE';

@Component({
  selector: 'app-tab-decorticage',
  templateUrl: './tab-decorticage.component.html',
  styleUrls: ['./tab-decorticage.component.css']
})
export class TabDecorticageComponent implements OnInit, AfterViewInit {

  // tslint:disable-next-line:no-output-on-prefix
  @Output('onDrawerStateChange') onDrawerStateChange: EventEmitter<boolean> = new EventEmitter();
  @Output('onAskSave') onAskSaveAnalysis: EventEmitter<any> = new EventEmitter(); // Emmit type dec @see CST_TYPE_ANALYSIS

  @ViewChild('drawerShape', {static: true}) mDrawerShape!: MatDrawer;
  @ViewChild('decoSiteSelect', {static: true}) mTabSiteSelection!: SiteSelectorComponent;
  @ViewChild('taDesignation', { static: true }) mTaDesignation!: ElementRef<HTMLInputElement>;
  @ViewChild('taNumplan', { static: true }) mTaNumPlan!: ElementRef<HTMLInputElement>;
  @ViewChild('tableDec', { static: true }) matTablearrayLineDec!: MatTable<CLineDec>;        // Afficher dans la table html
  @ViewChild('tableProduct', { static: true}) matTableArrayProduct!: MatTable<CProduct>;
  @ViewChild('inputVarious', { static: true} ) mInputVarious!: ElementRef<HTMLInputElement>;
  @ViewChild('inputCustRef', {static: true}) mInputCustRef!: ElementRef<HTMLInputElement>;
  @ViewChild('panelInfoOrder', {static: true}) mPanelInfoIOrder!: MatExpansionPanel;
  @ViewChild('panelProduct', {static: true}) mPanelProduct!: MatExpansionPanel;
  @ViewChild('panelAnalysis', {static: true}) mPanelAnalysis!: MatExpansionPanel;
  @ViewChild('armDatePicker', {static: true}) mArmaDatePicker!: ArmaDateTimePickerComponent;

  @ViewChild('colHeaderIdLine', {read: ElementRef}) mHeaderIdLine!: ElementRef<HTMLTableHeaderCellElement>; // Ref au header id du tableau de lignes
  @ViewChild('colHeaderMemberName', {read: ElementRef}) mHeaderMemberName!: ElementRef<HTMLTableHeaderCellElement>; // Ref au header nom d'élément du tableau de lignes
  @ViewChild('colHeaderSchema', {read: ElementRef}) mHeaderSchema!: ElementRef<HTMLTableHeaderCellElement>; // Ref au header dessin de forme du tableau de lignes

  @ViewChild('inputSelectFile', {static: true}) inputSelectFile!: ElementRef<HTMLInputElement>;

  @ViewChild('hoverRealShapeDrawing', {read: ElementRef}) mImgRealShapeDrawing!: ElementRef<HTMLImageElement>;
  @ViewChild('hoverMeshDrawing', {read: ElementRef}) mCanvasMeshDrawing!: ElementRef<HTMLCanvasElement>;

  public arrayAnalysisFile: AnalysisFile[] = [];

  private mOrderUnixDateCreate: number = 0;
  private mOrderNote?: string;

  private mOrderCode: string = '';

  public mPanelOrderInfoOpenState = true; // True si panel info commande ouvert, sinon false, init par default en true puis enregistrer dans le local storage

  HTML_RightClickMenuPosX: number = 0; // Pour la gestion
  HTML_RightClickMenuPosY: number = 0; // du clique droit

  HTML_LockAnalysis: boolean;     // Permet de bloquer tout les input/btn du component actuel

  HTML_LenghtMeasure: string;

  HTML_AnalysisWeight: number = 0; // Poids des aciers
  HTML_ProductWeight: number = 0; // Poids de tout les produits
  get HTML_AnalysisTotalWeight(): number { return this.HTML_ProductWeight + this.HTML_AnalysisWeight; } // Poids total du déco

  // ! Doit etre sur tout les input/btn du programme  !
  private mReadOnlyAnalysis: boolean; // Indique si le décorticate & en lecture seul, on bloque tout les action possible sur ce dernier

  lineCopied?: JsLineDec; // utiliser dans le HTML

  mInputType: 'Classical'|'BS 4466 / 8666' = CUtilit.loadOrInitUserParam().AnalysisInputType;

  private mAskToSave: boolean;

  public mLastIdLineSelected: number = 0; // est utiliser pour connaitre la derniere ligne qui a eu le focus, utiliser dans le css
  public mLastIdLineProductSelected: number = 0;
  private mLastNbInputFocused = 0;                //

  public arrayShape: Formes[] = []; // Liste des formes disponible pour le décorticage // UTILISER DANS LE HTML
  public arrayFavoriteShape: FavoriteShape[] = []; // Liste des numero de forme favorites (Dans l'ordre des palettes d'Armaor)

  dataSource: MatTableDataSource<CLineDec>; // Correspond au décorticage
  dataProduct: MatTableDataSource<CProduct>;

  mGradeManager: GradeManager;

  public utilitShapeDrawing: UtilitRealShapeDrawing;

  public contactInformation: ArmaRestContact|undefined = undefined;

  private mMenuOverProduct: boolean = false; // true si le menu contextuel pointe sur le tableau des produits

  HTML_ANALYSIS_COL_TYPE = {
    INPUT: 'input',
    MEASURE: 'measure'
  };

  /**
   * Nom pour les colonnes du décorticage, utiliser dans le html pour definir a qui appartien la colonne
   * @see getHtmlInputWithColnameNoline pour generer l'id dans le html
   * @see getInfoLineFromInput pour recuperer les infos depuis l'id
   */
  HTML_ANALYSIS_COL = {
    IdLine: 'IdLine',
    Membername: 'Membername',
    Barmark: 'Barmark',
    Qty: 'Qty',
    Diameter: 'Diameter',
    Grade: 'Grade',
    Length: 'Length',
    IdShape: 'IdShape',
    A: 'A',
    B: 'B',
    C: 'C',
    D: 'D',
    E_R: 'E/R',
    Schema: 'Schema',
    Comment: 'Comment',
    Distribution: 'Distribution',
    Weight: 'weight',
    RealShapeDrawing: 'RealShapeDrawing',
  };

  HTML_PRODUCT_COL = {
    IdLine: 'ProductIdLine',
    ProductLabel: 'ProductLabel',
    Qty: 'ProductQty',
    Unit: 'ProductUnit',
    Weight: 'ProductWeight'
  };

  /**
   * Retourne l'id de l'input tu tableau de décorticage en fonction du nom de la colone & du numéro de la ligne
   * @param colName see HTML_ANALYSIS_COL
   * @param noLine see CLineDec#mNoLine
   */
  getHtmlInputWithColnameNoline(colName: string, noLine: any): string {
    return this.HTML_ANALYSIS_COL_TYPE.INPUT + '-' + colName + '-' + noLine;
  }

  /**
   * Retourne les les infos de la ligne dec par rapport à l'id de l'input
   * Permet de faire lisiason avec le tableau de ligne
   *
   * Example id d'un input pour la colone du tableau : id=input-Barmark-3
   * Example id d'un input de mesure de la forme     : id=measure-3-3
   *
   * @see HTML_ANALYSIS_COL pour la correspondace des colone
   * @param inputElement Input a chercher
   */
  getInfoLineFromInput(inputElement: HTMLInputElement): {
    inputType: 'measure'|'input'|undefined; // Peut etre 'measure' (forme) ou 'input' (ligne), undefined si impossible de recup ou erreur
    /**
     * @see HTML_ANALYSIS_COL
     */
    colName: string;
    idLine: number;
    idMeasure: number;
  } {
    const splitResult = inputElement.id.split('-');
    // splitResult[0] Peut etre 'measure' ou 'input'
    let inputType: 'measure'|'input'|undefined;
    let colName: string | undefined = undefined;
    let idLine: number | undefined = undefined;
    let idMeasure: number | undefined = undefined;

    try {
      // Recupere les donnée depuis le split
      switch (splitResult[0]) {
        case 'input':   // Input de la ligne de décorticage
          inputType = 'input';
          colName = splitResult[1];
          idLine = +splitResult[2];
          break;
        case 'measure': // Input dédié à la forme
          inputType = 'measure';
          colName = this.HTML_ANALYSIS_COL.Schema; // On est toujours sur la colone des formes pour le cas des mesure
          idLine = +splitResult[1];
          idMeasure = +splitResult[2];
          break;
      }
    } catch (e) {
      console.error(e);
      inputType = undefined;
    }
    return {
      inputType: inputType,
      colName: colName ? colName : '',
      idLine: idLine ? idLine : 0,
      idMeasure: idMeasure ? idMeasure : 0
    };
  }

  getInfoFromInputMeasure(inputElement: HTMLInputElement): {
    type: 'measure' | 'input';
    data: string;
    colName?: string;
    idLine?: string; //TODO: Passer en number
    idInput?: string; //TODO: Passer en number
  } {
    const splitResult = inputElement.id.split('-');
    const type = (splitResult[0] as 'measure' | 'input');
    let colName: string | undefined = undefined;
    let idLine: string | undefined = undefined;
    let idInput: string | undefined = undefined;
    switch (type) {
      case 'measure':
        colName = this.HTML_ANALYSIS_COL.Schema;
        idLine = splitResult[1];
        idInput = splitResult[2];
        break;
      case 'input':
        colName = splitResult[1];
        idLine = splitResult[2];
        switch (colName) {
          case this.HTML_ANALYSIS_COL.A: idInput = '0'; break;
          case this.HTML_ANALYSIS_COL.B: idInput = '1'; break;
          case this.HTML_ANALYSIS_COL.C: idInput = '2'; break;
          case this.HTML_ANALYSIS_COL.D: idInput = '3'; break;
          case this.HTML_ANALYSIS_COL.E_R: idInput = '4'; break;
        }
        break;
    }
    return {
      colName: colName,
      idLine: idLine,
      idInput: idInput,
      type: type,
      data: inputElement.id
    };
  }

  constructor(private http: HttpClient,
              private mSanitizer: DomSanitizer,
              private mArmaServMethods: ArmaServServerMethods,
              public mDialog: MatDialog,
              private mToolbar: AppToolbarService,
              private mSnackBar: MatSnackBar,
              private mTranslatedService: TranslateService) {
    this.dataSource = new MatTableDataSource<CLineDec>([]);
    this.dataProduct = new MatTableDataSource<CProduct>([]);
    this.mGradeManager = new GradeManager([]);
    this.utilitShapeDrawing = new UtilitRealShapeDrawing(this.http, this.mSanitizer, this.mArmaServMethods);
    this.mAskToSave = false;
    this.HTML_LockAnalysis = false;
    this.mReadOnlyAnalysis = false;
    this.HTML_LenghtMeasure = '';
    this.mPanelOrderInfoOpenState = (
      localStorage.getItem(LOCAL_STORAGE_ORDER_PANEL_STATE) === '1' ||
      localStorage.getItem(LOCAL_STORAGE_ORDER_PANEL_STATE) === undefined
    );
  }

  ngOnInit() {
    this.HTML_LenghtMeasure = g_params.measureUnitStr;
    //this.loadColumnOrder();   // Init de l'entete du tableau
    if (this.mPanelOrderInfoOpenState)
      this.mPanelInfoIOrder.open();
    this.mToolbar.getObservableSiteChange().subscribe(site => { this.onSiteCodeChange(site); });
  }

  ngAfterViewInit() {
    this.utilitShapeDrawing.imageSrc = this.mImgRealShapeDrawing.nativeElement;
    this.utilitShapeDrawing.canvasSrc = this.mCanvasMeshDrawing.nativeElement;
  }

  onFileSelected(event: Event) {
    if (event.target instanceof HTMLInputElement && event.target.files) {
      if (typeof (FileReader) !== 'undefined') {
        const files: FileList = event.target.files;
        for (let i = 0 ; i < files.length ; i++)
          this.addFile(files[i]);
      }
    }
  }

  public addFile(file: File) {
    if (!file)
      return;
    this.arrayAnalysisFile.push({
      fileName: file.name,
      isSend: false,
      inProgress: false,
      file: file
    });
  }

  public async removeFile(event: Event, index: number) {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (this.arrayAnalysisFile[index].inProgress)
      return;
    // Info pour l'ui pour indiquer qu'on est en train de l'effacer
    this.arrayAnalysisFile[index].inProgress = true;
    // On le supprime du web si il est présent
    if (this.arrayAnalysisFile[index].isSend)
      await ArmaServConnection.aGET(this.http, 'RemoveFileForSteelList', [this.mOrderCode, this.arrayAnalysisFile[index].fileName]);
    // On le supprime de la liste
    this.arrayAnalysisFile.splice(index, 1);
    return true;
  }

  public async uploadFile(orderCode: string) {
    const fileImport = new FilImportUtilit(this.http, orderCode);
    this.arrayAnalysisFile.forEach(analysisFile => {
      if (!analysisFile.isSend) {
        analysisFile.inProgress = true; // Info ui pour indiquer que l'on upload le fichier
        if (analysisFile.file)
          fileImport.addFile(analysisFile.file);
      }
    });
    await fileImport.waitToFinish(true);
  }

  public async loadFileFromServer(clearArray: boolean) {
    if (clearArray)
      this.arrayAnalysisFile.length = 0;
    const result: string[] = await (await ArmaServConnection.aGET(this.http, 'GetListFileForSteelList', [this.mOrderCode])).result[0];
    result.forEach(fileName => this.arrayAnalysisFile.push({
      fileName: fileName,
      file: undefined,
      inProgress: false,
      isSend: true
    }));
  }

  public getArrayLineDec(): CLineDec[] {
    const result: CLineDec[] = [];
    console.log('DATASOURCE : ', this.dataSource.data);
    for (let i = 0; i < this.dataSource.data.length; i++) {
      result.push(this.dataSource.data[i]);
    }
    // On boucle depuis la fin du tableau pour enlever toute les ligne vide, on stop à la premier ligne non vide trouvée
    let j = result.length - 1;
    while ((result.length !== 0) && (result[j].isEmpty())) {
      result.length = j;
      j--;
    }
    return result;
  }

  public getArrayProduct(): CProduct[] {
    const result: CProduct[] = [];
    for (let i = 0; i < this.dataProduct.data.length; i++) {
      result.push(this.dataProduct.data[i]);
    }
    return result;
  }

  // Retourne le contexte d'affichage du menu clique droit
  getContextMenuType(): 'repartition'|'affecteRepartition'|'line' {
    const line: CLineDec | null = this.getSelectedLine();
    if (line != null) {
      if ((this.HTML_RightClickMenuPosX > this.mHeaderSchema.nativeElement.getBoundingClientRect().left) &&
          (this.HTML_RightClickMenuPosX < this.mHeaderSchema.nativeElement.getBoundingClientRect().right)) {
        if (line.isARepartition()) {
          return 'repartition';
        }
        if ((this.listRepartitionLine.length > 0 || line.mFilantRepart > 0) && (!this.isAStirrup(line))) {
          return 'affecteRepartition';
        }
      }
    }
    return 'line';
  }

  // Retourne la ligne d'élément depuis le noLine
  public getMemberFromLine(line: number|CLineDec): CLineDec | null {
    let index: number;
    // Récupère l'index de la ligne (on peut passer la ligne ou l'index)
    if (typeof line === 'number')
      index = line;
    else
      index = this.dataSource.data.indexOf(line);

    if (this.dataSource.data.length >= index)
      for (let i = index ; i > -1 ; i--) {
        if (this.dataSource.data[i].mMemberName != '') {
          return this.dataSource.data[i];
        }
      }
    return null;
  }

  // Retourne la liste des lignes de l'élément
  getMemberLines(member: CLineDec): CLineDec[] {
    const lines: CLineDec[] = [];
    const indexMember: number = this.dataSource.data.indexOf(member);
    for (let i = indexMember ; i < this.dataSource.data.length ; i++) {
      if (this.dataSource.data[i].hasMember && (this.dataSource.data[i] != member))
        break;
      lines.push(this.dataSource.data[i]);
    }
    return lines;
  }

  // Retourne true si la ligne donnée est un cadre (après une répartition du même élément)
  isAStirrup(line: CLineDec): boolean {
    const member: CLineDec | null = this.getMemberFromLine(line);
    if (!member)
      return false;
    const memberLines: CLineDec[] = this.getMemberLines(member);
    for (let i = 0 ; i < memberLines.length ; i++) {
      if (memberLines[i] == line)
        return false;
      if (memberLines[i].isARepartition())
        return true;
    }
    return false;
  }

  // Renvoit la liste des répartitions du même élément sous la ligne actuellement focus
  get listRepartitionLine(): CLineDec[] {
    const result: CLineDec[] = [];
    for (let i = this.mLastIdLineSelected ; i < this.dataSource.data.length; i++) {
      if (this.dataSource.data[i].isARepartition()) {//Une ligne de répartition
        result.push(this.dataSource.data[i]);
      }
      if (this.dataSource.data[i].hasMember) {
        break;
      }
    }
    return result;
  }

  // Parcourt les lignes jusqu'à la répartition pour connaitre son index (todo:: réduire la recherche à la range de l'élément)
  getRepartitionIndex(repart: CLineDec): number | null {
    let index = 0;
    const member: CLineDec | null = this.getMemberFromLine(repart);
    if (!member)
      return null;
    const memberLines: CLineDec[] = this.getMemberLines(member);
    for (let i = 0 ; i < memberLines.length ; i++) {
      if (memberLines[i] == repart)
        return index;
      if (memberLines[i].isARepartition())
        index++;
    }
    return null;
  }

  // Si la répartition "noRepart" est déjà liée pour la ligne "line"
  isRepartitionLinked(noRepart: number, line: CLineDec): boolean {
    const sLineRepart: number[] = CUtilit.IntToBinArray(line.mFilantRepart);
    return (sLineRepart[noRepart] == 1);
  }

  // Affecte/Dé-affecte la répartition "noRepart" pour la ligne "newLine"
  toggleRepartition(noRepart: number, newLine: CLineDec) {
    const repartBin: number[] = CUtilit.IntToBinArray(newLine.mFilantRepart);
    //Si le numéro Répartition est déjà utilisé
    if ((repartBin.length >= noRepart) && (repartBin[noRepart] == 1))
      newLine.mFilantRepart -= Math.pow(2, noRepart);
    else {
      //Supprime l'affectation filant si elle est déjà utilisée
      const member: CLineDec | null = this.getMemberFromLine(newLine);
      if (!member)
        return null;
      const memberLines: CLineDec[] = this.getMemberLines(member);
      memberLines.forEach(line => {
        if (this.isRepartitionLinked(noRepart, line)) {
          this.toggleRepartition(noRepart, line);
        }
      });
      newLine.mFilantRepart += Math.pow(2, noRepart);
    }
  }

  distributionSymmetry(line: CLineDec) {
    let repart: string = line.mRepartition || '';
    const splitRepart: string[] = repart.split('/').filter(element => {
      return element.length != 0;
    });
    const numRepart = splitRepart.length;
    const beginRepart = 0;
    const endRepart: number = numRepart - 1;
    //Ajoute les répartitions juste après la dernière partie de la répartition
    for (let i = beginRepart ; i < endRepart ; i++) {
      splitRepart.splice(numRepart, 0, splitRepart[i]);
    }
    repart = '';
    splitRepart.forEach(element => {
     repart += element + '/';
    });
    line.mRepartition = repart;
  }

  toggleCrochetLevage(line: CLineDec) {
    line.mRepartCrochetLevage = !line.mRepartCrochetLevage; // Boolean donc soit 0 soit 1
  }

  // Envoit le texte de répartition et la longueur affectée au serveur et renvoit la répartition "décodée" comme dans Armaor ex: x/x avec longueur 500 => 250/250
  async handleRepartitionFromArmaServ(element: CLineDec, repart: string): Promise<string> {
    let handledRepart = '';
    if (repart == '') throw 'Unable to handle empty distribution';
    try {
      // Chargement des données depuis armaserv
      const data = [];
      const member: CLineDec | null = this.getMemberFromLine(element);
      if (!member)
        return '';
      const lines: CLineDec[] = this.getArrayLineDec();
      //Récupère la liste des lignes de l'élément jusqu'à la répartition "element"
      for (let i = lines.indexOf(member) ; i < lines.length ; i++) {
        //Convertit la liste des lignes en JSON
        data.push(lines[i].toJsLineDec(true));
        if (lines[i] == element)
          break;
      }
      const body = {
        'REPART': element.mRepartition,
        'Data': data
      };
      handledRepart = ((await ArmaServConnection.aPOST(this.http, 'GetProcessedRepartition', body, [])).result[0]);
    } catch (e) {
      console.error(e);
    }
    return handledRepart;
  }

  async onRepartitionChanged(line: CLineDec, event: any) {
    if (!line) return;
    const indexRepartition = this.getRepartitionIndex(line);
    //Impossible de récupérer l'index de la répartition
    if (indexRepartition == null)
      return;
    //On récupère la ligne de répartition affectée (si aucune affectation, on prend la plus longue ligne)
    this.handleRepartitionFromArmaServ(line, event).then(repart => {
      line.mRepartition = repart;
    });
  }

  /**
   * Utilisé pour remplir la liste d'acier
   * @returns Le contenue du panel d'info du contrat.
   */
  public getOrderInfo(): OrderInfo {
    let unixDateDelivery = undefined;
    if (this.mArmaDatePicker.valueInput instanceof Date)
      unixDateDelivery = ArmaDate.createFromDate(this.mArmaDatePicker.valueInput).toUnixTimestamp();
    return {
      Designation: this.mTaDesignation.nativeElement.value,
      NumPlan: this.mTaNumPlan.nativeElement.value,
      Various: this.mInputVarious.nativeElement.value,
      SiteCode: this.mTabSiteSelection.HTML_SelectSiteCode,
      CustomerRef: this.mInputCustRef.nativeElement.value,
      UnixDateDelivery: unixDateDelivery,
      IdContact: this.contactInformation?.Id,
      UnixDateCreate: this.mOrderUnixDateCreate,
      Note: (this.mOrderNote ?? '')
    };
  }

  public setOrderInfo(orderInfo: OrderInfo) {
    this.mTaDesignation.nativeElement.value = orderInfo.Designation;
    this.mTaNumPlan.nativeElement.value = orderInfo.NumPlan;
    this.mInputVarious.nativeElement.value = orderInfo.Various;
    //this.mTabSiteSelection.HTML_SelectSiteCode = // Le code chantier estd déja definit avant
    this.mInputCustRef.nativeElement.value = orderInfo.CustomerRef;
    if (orderInfo.UnixDateDelivery !== undefined) {
      const dateDelivery = ArmaDate.createFromUnixTime(orderInfo.UnixDateDelivery).getClonnedDate();
      this.mArmaDatePicker.setDateAsync(dateDelivery);
    }
    this.mArmaDatePicker.loadNoOpenDay(CUtilit.selectedDefaultFactory).catch(console.error);
    this.mOrderUnixDateCreate = orderInfo.UnixDateCreate;
    // Chargement des infos du contact
    if (orderInfo.IdContact)
      this.mArmaServMethods.getContact(orderInfo.IdContact).then(value => this.contactInformation = value);
    this.mOrderNote = orderInfo.Note;
  }

  /**
   * Init le tableau de décorticage avec une liste d'acier
   * @param code Code à charger
   * @param orderInfo En-tête de la liste d'acier
   * @param readOnlyAnalysis Decorticage en lecture seul
   * @param checkBackup Verifier si un backup existe dans le local storage pour ce décorticage
   */
  public async initAnalysis(code: number,
                            orderInfo: OrderInfo,
                            readOnlyAnalysis: boolean,
                            checkBackup: boolean = true) {
    this.mOrderCode = code.toString();
    this.mReadOnlyAnalysis = readOnlyAnalysis;
    this.setOrderInfo(orderInfo);
    await this.loadAnalysisByCodeSteelListFromArmaServ(checkBackup);
  }

  /**
   * Init le tableau de décorticage a vide
   * Crée une liste d'acier vide avec le code -1
   * @param checkBackup Verifier si un backup existe dans le local storage pour ce décorticage
   */
  public async initEmptyAnalysis(checkBackup: boolean = true) {
    this.lockAnalysis = true; // On block les btns de l'interface le temps de charger les données
    try {
      this.mOrderCode = '-1';
      this.mReadOnlyAnalysis = false;
      const siteCode = CUtilit.getSelectedSiteCode();
      await this.loadGradeAndDiamFromRest();
      // On crée une interface liste d'acier avec des param par default
      this.setOrderInfo({
        CustomerRef: '',
        Designation: '',
        NumPlan: '',
        UnixDateDelivery: undefined,
        Various: '',
        IdContact: undefined,
        UnixDateCreate: ArmaDate.toUnixTimestamp(new Date()),
        Note: '',
      });
      // On ouvre par default le panel des infos de la commandde
      this.mPanelInfoIOrder.open();
      // Prepare un CDec vide & on recupere la liste des formes disponible pour le chantier
      const emptyAnalysis = await this.mArmaServMethods.loadEmptyAnalysis(siteCode);
      // Enregistrement des formes pour le deco
      this.arrayShape = emptyAnalysis.shapeAvailable;
      this.arrayFavoriteShape = emptyAnalysis.shapeFavorite;
      // On genere les status favoris des formes qui n'en ont pas encore
      this.fillBookmarkedShape();
      // Backup
      if (checkBackup) {
        const backup = BackupDec.loadAnalysisBackup(this.mOrderCode);
        if (backup) {
          // On écrase les infos de la liste d'acier
          this.setOrderInfo(backup.orderHeader);
          // Remplisage des tableaux avec le backup
          const arraysLine = TabDecorticageComponent.getJsLineDecToArray(backup.jsonLineDec);
          this.fillArrayLineDecAndProduct(arraysLine.arraySteel, arraysLine.arrayProduct, true);
          // On supprimer les ligne vide que le backup a generer
          this.removeEmptyLine();
          // Re calcule des poids totals
          this.calcAnalysisWeight();
          this.calcProductWeight();
          // On notifie à l'écran la recupeartion du backup
          CUtilit.showSnackBar(this.mSnackBar, this.mTranslatedService, 'Sauvegarde restaurée', undefined, 3);
          this.askToSave = true; // Modification des données donc on demande pour sauvegarder avant de fermer le deco
        }
      }
    } finally {
      this.lockAnalysis = false;
    }
  }

  /**
   * On genere les status favoris des formes qui n'en ont pas encore
   */
  private fillBookmarkedShape() {
    // this.arrayFavoriteShape.length = 0;
    this.arrayShape.forEach(forme => {
      const indexFavoriteShape: number = this.arrayFavoriteShape.map((value) => value.NoForme).indexOf(forme.CleForme);
      if (indexFavoriteShape == -1) {
        let status: FavoriteShapeStatus = FavoriteShapeStatus.Default;
        if (forme.WebSelectable == 2) {
          status = FavoriteShapeStatus.PanelVisible;
        }
        this.arrayFavoriteShape.push({NoForme: forme.CleForme, Status: status, PanelVisible: forme.WebSelectable != 2});
      }
    });
  }

  getErrorLineDec(lineDec: CLineDec, showAlert: boolean): string {
    if (!lineDec)
      return '';
    if (showAlert) {
      const errorLineDec: ErrorLineDec[] = [];
      lineDec.getLastArrayerrorMessage().forEach(errorStr => {
        errorLineDec.push({
          NoLine: undefined,
          NoLineWeb: +lineDec.mNoLine,
          IsBlocking: 0,
          Mess: errorStr,
        });
      });
      // Pas bessoins de passer le tableau de décorticage
      DialogErreurLineDecComponent.showErrorAnalysis(this.mDialog, errorLineDec, 'Error');
    }
    return lineDec.getOneLineLastErrorMessage();
  }

  /**
   * TODO à déplacer dans l'init all ?
   * Charge la liste des nuance & des diametre disponible
   */
  async loadGradeAndDiamFromRest() {
    this.mGradeManager.LoadGrades(this.http);
  }

  async loadAnalysisByCodeSteelListFromArmaServ(checkBackupSteellist: boolean) {
    // On stop si on n'a pas de code steel liste
    if (+this.mOrderCode <= 0) throw 'Unable to load steel lsit code:' + this.mOrderCode;
    // On block les btns de l'interface le temps de charger les données
    this.lockAnalysis = true;
    try {
      // Chargement des diametre et des nuance
      await this.loadGradeAndDiamFromRest();

      let backup: BackupDecInterface|undefined = undefined;
      // Chargement des données depuis armaserv
      const loadedAnalysis: LoadedAnalysis = (await ArmaServConnection.aGET(this.http, 'LoadAnalysisById', [this.mOrderCode])).result[0];
      console.log('Loaded order code ' + loadedAnalysis.infoSteelList.Code);
      // Verification des backup sur le navigateur
      if (checkBackupSteellist) {
        backup = BackupDec.loadAnalysisBackup(this.mOrderCode);
        if (backup) {
          // On reaffecte l'entet de la commande
          this.setOrderInfo(backup.orderHeader);
          // Notification que la backup a été recup
          CUtilit.showSnackBar(this.mSnackBar, this.mTranslatedService, 'Sauvegarde restaurée', undefined, 3);
          this.askToSave = true; // Il y a potentielement une modification des données donc on demande pour sauvegarder
        }
      }

      // Chargement des fichier présent pour la liste d'acier
      this.loadFileFromServer(true);

      // Affectation des forme du décorticage + formes disponible
      this.arrayShape = loadedAnalysis.shapeAvailable;
      // Affectation des formes favorites du client
      this.arrayFavoriteShape = loadedAnalysis.shapeFavorite;
      // On genere les status favoris des formes qui n'en ont pas encore //TODO CHECK
      this.fillBookmarkedShape();

      // Chargement des lignes de décorticage
      let arraysLineDec = undefined;
      // Si on a trouvé une backup on ne lit pas le contenue du décorticage, on reaffecte les lignes depuis la backup
      if (checkBackupSteellist && backup !== undefined) {
        arraysLineDec = TabDecorticageComponent.getJsLineDecToArray(backup.jsonLineDec); // Depuis le backup
      } else {
        arraysLineDec = TabDecorticageComponent.getJsLineDecToArray(loadedAnalysis.arrayLineDec); // Depuis le dec chargé
      }
      // Remplisage des tableaux
      this.fillArrayLineDecAndProduct(arraysLineDec.arraySteel, arraysLineDec.arrayProduct, true);

      // Re calcule des poids totals
      this.calcAnalysisWeight();
      this.calcProductWeight();
    } catch (e) {
      console.error(e);
    } finally {
      this.lockAnalysis = false; // Débloquage des btns
    }
  }

  /**
   * Remplis les deux different tableaux du décorticage
   * Ouvre automatiquement les panels si les tableaux sont remplis
   * @param arrayLineSteek tableau de ligne d'acier
   * @param arrayLineProduct tableau de ligne de produit
   * @param clearDataSource boolean, pour indiquer si on veux effacer le tableau avant de le remplir
   */
  private fillArrayLineDecAndProduct(arrayLineSteek: CLineDec[], arrayLineProduct: CProduct[], clearDataSource: boolean) {
    // Clear du data source
    if (clearDataSource) {
      this.dataSource.data = [];
      this.dataProduct.data = [];
    }
    // Replisage des lignes acier
    if (arrayLineSteek)
      this.dataSource.data.push(...arrayLineSteek);

    // Remplisage des lignes de produit
    if (arrayLineProduct)
      this.dataProduct.data.push(...arrayLineProduct);

    // Force le rendu sur le HTML
    this.matTablearrayLineDec?.renderRows();
    this.matTableArrayProduct?.renderRows();

    // Ouverture du panel deco si remplis
    if (this.dataSource.data.length > 0) {
      this.mPanelAnalysis.open();
      if (!this.HTML_ReadOnlyAnalysis)
        this.ajouterLigneDec(); // On ajoute une ligne à la fin du décorticage
    }

    // Ouverture du panel produit si remplis
    if (this.dataProduct.data.length > 0) {
      this.mPanelProduct.open();
    }

    // Ouverture du panel d'info du contrat si aucune donnée remplis
    if (this.dataSource.data.length == 0 && this.dataProduct.data.length == 0)
      this.mPanelInfoIOrder.open();
  }

  /**
   * Traite l'interface de line dec passé en param pour retourner un tableau d'acier & un tableau de produit
   * @param arrayLineDec Interface line dec recup depuis le rest ou le backup
   * @returns Une interface qui contiens deux tableaux
   */
  private static getJsLineDecToArray(arrayLineDec: JsLineDec[]): {
    arraySteel: CLineDec[], // Pour les lignes de déco
    arrayProduct: CProduct[] // Pour les lignes de produit
  } {
    if (!arrayLineDec) {
      console.warn('Empty line dec ', arrayLineDec);
      return { arrayProduct: [], arraySteel: [] };
    }
    const resultArraySteel: CLineDec[] = [];
    const resultArrayproduct: CProduct[] = [];

    for (let i = 0; i < arrayLineDec.length; i++) {
      if (UtilitAnalysis.getTypeJsLineDec(arrayLineDec[i]) == 'ProductLine') {
        // Si c'est un produit, on l'ajoute aux lignes des produits (tableau a part)
        resultArrayproduct.push(CProduct.LoadFromArmaor(arrayLineDec[i]));
        // On update le numéro de ligne pour le tableau de produit
        resultArrayproduct[resultArrayproduct.length - 1].mNoLine = resultArrayproduct.length;
      } else {
        const lineDec: CLineDec = CLineDec.LoadFromArmaor(arrayLineDec[i]);
        // Sinon on l'ajoute aux lignes du décorticage clasique (steel)
        resultArraySteel.push(lineDec);
      }
    }
    return { arraySteel: resultArraySteel, arrayProduct: resultArrayproduct};
  }

  private addLineDecIfLastLine(idLine: any) {
    const currentLine = this.getLineDecFromArrayByIdLigne(idLine);
    if (this.isLastLine(currentLine)) {
      this.ajouterLigneDec();
      // Si on ajoute une ligne on s'assure de scroll jusqua la derniere ligne
      const divTableDeco = document.getElementById('table');
      // Le parent du parent correspond a la balise du mat-expansion-panel-content qui est crée dans le composant mat-expansion-panel
      // Pas possible de le selectionner directement
      if (divTableDeco && divTableDeco.parentElement && divTableDeco.parentElement.parentElement)
        divTableDeco.parentElement.parentElement.scrollTo(0, divTableDeco.scrollHeight);
    }
  }

  public ajouterLigneDec() {
    const newLineDec = new CLineDec();
    let numLine = 1;
    if (this.dataSource.data && this.dataSource.data.length != 0) {
      numLine = +this.dataSource.data[this.dataSource.data.length - 1].mNoLine + 1;
    }
    newLineDec.mNoLine = numLine.toString();
    this.dataSource.data.push(newLineDec);
    this.matTablearrayLineDec?.renderRows();
    this.dataSource._updateChangeSubscription();


  }

  isLastLine(currentLine: CLineDec | null): boolean {
    if (!currentLine)
      return false;
    const idCurrentLine = parseInt(currentLine.mNoLine.valueOf(), 10);
    if (idCurrentLine == NaN || (this.dataSource.data.length - 1) == 0)
      return true;
    return idCurrentLine == this.dataSource.data.length;
  }

  /**
   * Cette fonction est appelé a chaque fois que l'on change d'input apres avoir fait une modification.
   * @param line La ligne qui a eu la modification
   */
  async onValueLineChange(line: CLineDec | CProduct) {
    this.mAskToSave = true;
    if (line instanceof CLineDec) {
      const lineDec: CLineDec = line as CLineDec;
      await this.refreshLineArmaServ(lineDec);
      this.calcAnalysisWeight();
    } else if (line instanceof CProduct) {
      this.calcProductWeight();
    }
    this.backupAnalysis();
    this.utilitShapeDrawing.razImage();
  }

  /**
   * Update aussi dans le HTML
   */
  public backupAnalysis() {
    console.log('backupAnalysis');
    // On remplis le tableau de jsonlinedec
    const arrayLineDec: JsLineDec[] = UtilitAnalysis.convertToJsLineDecProduct(this.dataSource.data, this.dataProduct.data);

    // Fait un backup a chaque modification d'input
    BackupDec.updateAnalysisBackup({
      code: this.mOrderCode,
      orderHeader: this.getOrderInfo(),
      jsonLineDec: arrayLineDec
    });
  }

  onRightClick(event: MouseEvent, idLine: any, menuTrigger: MatMenuTrigger) {
    // @ts-ignore //TODO: TS2531: Object is possibly 'null'.
    const targetProduct: boolean = ((event.target as HTMLElement).closest('table').id == 'table-product');
    if (this.isReadOnlyOrLock) return true; // On stop si on est en lecture seul ou lock
    if (!menuTrigger) return true;
    if (!targetProduct) {
      if (!idLine) return true; // On gere pas le click droit si pas de ligne decorticage selectionée
      this.mLastIdLineSelected = +idLine;
    } else {
      this.mLastIdLineProductSelected = +idLine;
    }
    this.mMenuOverProduct = targetProduct;
    this.HTML_RightClickMenuPosX = event.x;
    this.HTML_RightClickMenuPosY = event.y - this.mToolbar.getToolbarHeight();
    menuTrigger.openMenu();
    return false;
  }

  /**
   * Quand on clique sur une colone du tableau de ligne d'acier
   * @param event element html utilisé pour le click
   * @param idLine Id de la ligne focus
   */
  onColFocus(event: any, idLine: any) {
    const lineChanged = +this.mLastIdLineSelected != +idLine;
    this.mLastIdLineSelected = idLine; // On met à jour la ligne focus
    if (this.isReadOnlyOrLock) return true; // On stop si on est en lecture seule ou lock
    if (event && !(event.target instanceof HTMLInputElement)) {
      // Recherche d'un input dans l'element
      const arrayOfInput = CUtilit.findInputsInHtmlElement(event.target);
      if (arrayOfInput.length > 0) {
        arrayOfInput[0].focus(); // Focus du premier input trouvé
      }
    }
    this.addLineDecIfLastLine(idLine);
  }

  /**
   * On fait ici le traitement spécifique a l'input que l'on a de focus
   * Si on doit faire un traitement sur la ligne, go utiliser #onColFocus
   * Rajoute une ligne si on se situe sur la dernierre
   * Fait du traitement si on est sur un input du tableau
   *
   * @param event  EventmentDeclancheur du focus
   * @param idLine Id de la nouvelle ligne [ 1 : ∞ ]
   */
  onInputFocus(event: FocusEvent, idLine: any) {
    /**
     * Pour eviter la repetition de code
     */
    function updateAndSelectInput(input: HTMLInputElement, value: any) {
      input.value = value;
      input.select();
    }
    this.mLastIdLineSelected = idLine; // On met à jour la ligne focus
    // Verification que l'on focus bien un input
    if (event.target instanceof HTMLInputElement) {
      // Recup des info de l'event
      const htmlInput: HTMLInputElement = (event.target as HTMLInputElement);
      const infoInput = this.getInfoFromInputMeasure(htmlInput);
      // Enregistre l'id de l'input séléctionner sur la ligne actuelle
      const lineDec = this.getLineDecFromArrayByIdLigne(idLine);
      if (!lineDec)
        return;
      this.mLastNbInputFocused = this.findIdInArrayofInput(lineDec, htmlInput);

      // Si la ligne est vide
      if (!(htmlInput as HTMLInputElement).value) {
        const userParam = CUtilit.loadOrInitUserParam();
        // Recuperation des infos de la ligne
        let valueChange = false;
        if (infoInput && +(infoInput.idLine ?? '') == 1) {
          if (infoInput.colName == this.HTML_ANALYSIS_COL.Barmark) {
            if (userParam.InputPreviousBM == 'letter')
              lineDec.mBM = 'A';
            else if (userParam.InputPreviousBM == 'number')
              lineDec.mBM = '1';
          }
        } else if (infoInput && +(infoInput.idLine ?? '') > 1) { // Si on est sur autre ligne que la premiere du déco
          // On recupere la ligne précedente
          let previousI = 0;
          let previousLine: CLineDec | null = null;
          do {
            previousI++;
            previousLine = this.getLineDecFromArrayByIdLigne((+(infoInput.idLine ?? '') - previousI).toString());
          } while ((+(infoInput.idLine ?? '') - previousI > 0) && previousLine != null && previousLine.isARepartition());
          // Pour la colone correspondante on ecrit les données
          // Si on arrive pas a trouver l'anciene ligne alors on ne fait plus rien
          if (previousLine == null)
            return;
          switch (infoInput.colName) {
            case this.HTML_ANALYSIS_COL.Barmark:
              // Verifier l'option que l'on a pour les repres
              if (userParam.InputPreviousBM == 'letter' && previousLine.mBM) {
                lineDec.mBM = CUtilit.getNextLetter(previousLine.mBM);
              } else if (userParam.InputPreviousBM == 'number' && previousLine.mBM && !isNaN(+previousLine.mBM)) {
                // Si on a bien un chiffre sur la ligne precedente
                lineDec.mBM = ((+previousLine.mBM) + 1).toFixed();
              }
              // Regarder le bar mark de la ligne du dessus
              // Complementer en fonction de la ligne du dessus
              break;
            case this.HTML_ANALYSIS_COL.IdShape:
              if (userParam.InputPreviousShape) {
                lineDec.mCodeF = previousLine.mCodeF;
                const lineDecByIdLine = this.getLineDecFromArrayByIdLigne((infoInput.idLine ?? ''));
                if (lineDecByIdLine != null)
                  this.onCodeFormeChange(lineDecByIdLine, previousLine.mCodeF);
                updateAndSelectInput(htmlInput, lineDec.mCodeF);
                valueChange = true;
              }
              break;
            case this.HTML_ANALYSIS_COL.Diameter:
            //case this.HTML_ANALYSIS_COL.Grade: // Il faut gerer le grade aussi
              if (userParam.InputPreviousGrade) {
                lineDec.mDiamGrade = previousLine.mDiamGrade;
                valueChange = true;
              }
              if (userParam.InputPreviousDiamter) {
                lineDec.mDiamNum = previousLine.mDiamNum;
                updateAndSelectInput(htmlInput, lineDec.mDiamNum);
                this.checkDiam(lineDec);
                valueChange = true;
              }
              break;
            case this.HTML_ANALYSIS_COL.Qty:
              const previousLineRepart: CLineDec | null = this.getLineDecFromArrayByIdLigne((+(infoInput.idLine ?? '') - 1).toString());
              if (previousLineRepart != null && previousLineRepart.isARepartition()) {
                lineDec.mQty = previousLineRepart.getNbCadres().toString();
              } else if (userParam.InputPreviousQty) {
                lineDec.mQty = previousLine.mQty;
                updateAndSelectInput(htmlInput, lineDec.mQty);
                valueChange = true;
              }
              break;
            case this.HTML_ANALYSIS_COL.A:
            case this.HTML_ANALYSIS_COL.B:
            case this.HTML_ANALYSIS_COL.C:
            case this.HTML_ANALYSIS_COL.D:
            case this.HTML_ANALYSIS_COL.E_R:
            case this.HTML_ANALYSIS_COL.Schema:
                const arrayMeasure = ArmaShapeUtilit.getArrayOfMeasuerInput(lineDec.mNoLine);
                const infoInputIdInput = +(infoInput.idInput ?? '');
                if (userParam.InputPreviousMeasure) {
                  // @ts-ignore // TODO: TS2339: Property 'writable' does not exist on type 'HTMLInputElement'.
                  if (arrayMeasure[infoInputIdInput] && arrayMeasure[infoInputIdInput].writable) {
                    lineDec.mArrayCote[infoInputIdInput] = previousLine.mArrayCote[infoInputIdInput];
                    updateAndSelectInput(htmlInput, lineDec.mArrayCote[infoInputIdInput]);
                    valueChange = true;
                  }
                }
              break;
            case this.HTML_ANALYSIS_COL.Distribution:
              break;
          }
        }
        if (valueChange)
          this.onValueLineChange(lineDec);
      }
     htmlInput.select();    // On selectionne le contenu de l'input
    } else {
      console.error('onInputFocus: not a input');
    }
    this.addLineDecIfLastLine(idLine);
  }

  findIdInArrayofInput(line: CLineDec, inputToFind: HTMLInputElement): number {
    const arrayOfInput = this.getArrayOfInputForOneLine(line);
    for (let i = 0; i < arrayOfInput.length; i++) {
      const input = arrayOfInput[i];
      if (input.id == inputToFind.id) {
        return i;
      }
    }
    return 0;
  }

  onKeyUp(event: any) {
    if (event instanceof KeyboardEvent) {
      switch (event.key) {
        case 'Enter':
          this.focusNextInput();
        break;
        case 'Tab':
          event.preventDefault(); // Bloque l'execution normal de la touche
          if (event.shiftKey)
            this.focusPreviousInput();
          else
            this.focusNextInput();
          event.stopImmediatePropagation(); // Bloque l'execution notmal de la touche
          return false;
        break;
        case 'ArrowUp': this.focusUpInput(); break;
        case 'ArrowDown': this.focusDownInput(); break;
      }
    }
  }

  onTableKeyDown(event: any) {
    if (event instanceof KeyboardEvent) {
      switch (event.key) {
        case 'Tab':
          event.preventDefault();
          event.stopImmediatePropagation();
          return false;
        break;
        case 's':
          if (event.ctrlKey) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.onAskSaveAnalysis.emit();
          }
          return true;
        break;
      }
    }
  }

  insertLines(newLines: CLineDec[], noLine: number) {
    const nbLinesAdded: number = newLines.length;
    newLines.forEach((line, index) => {
      this.dataSource.data.splice(noLine + index, 0, line);
    });
    // On shift le noLine des lignes qui suivent celles insérées
    for (let i = noLine + nbLinesAdded ; i < this.dataSource.data.length ; i++) {
      this.dataSource.data[i].mNoLine = (+this.dataSource.data[i].mNoLine + nbLinesAdded).toString();
    }
  }

  /**
   * @param lineDec Si undefined alors on tente de recup la ligne en cours
   */
  async openShape99(lineDec?: CLineDec  | null) {
    if (!lineDec)
      lineDec = this.getLineDecFromArrayByIdLigne(this.mLastIdLineSelected ? this.mLastIdLineSelected.toString() : '1');
    if (!lineDec)
      return;
    // Si on est sur une répartition ou un produit on ne fait rien
    const selectedLine = this.getSelectedLine();
    if (selectedLine && selectedLine.isARepartition())
      return;
    const result = await DialogShape99.openDialog(this.mDialog, lineDec, this.mGradeManager.GetArrayGrade());
    if (result) {
      lineDec.update(result);
      await this.checkDiam(lineDec); // Calculer la nuance lineDec.mDiamGrade      // appel de la fonction qui permet de calculer le diamGrade et l'assigné à la colonne voulu
      this.onValueLineChange(lineDec);
    }
  }

  async openProductInput() {
    const result = await DialogProductInput.openDialog(this.mDialog, 'AddProdInAnalysis');
    if (result) {
      result.forEach((product, index) => {
        product.mNoLine = this.dataProduct.data.length + 1;
        this.dataProduct.data.push(product);
        console.log(product.mU1Weight);
        this.onValueLineChange(product);

      });
      this.matTableArrayProduct?.renderRows();
    }
  }

  private async focusPreviousInput(nbRecall: number = 0, firstInput = undefined) {
    // TODO : Reprend le même principe que next input, il faut sortire le code de nextinput pour evitre duplication de code
    // Direction, next or previous
  }

  /**
   * Fonction qui permet d'avoir le focus sur le prochain input important du décorticage.
   * @param nbRecall Pour le recusivité, si le prochain input n'est pas importnat on r'appel la fonction en incrémentant ce param.
   */
  private async focusNextInput(nbRecall: number = 0, firstInput = undefined) {
    //if (nbRecall != 0) console.log('focusNextInput call No ' + (nbRecall+1));
    if (nbRecall > 20) { // Evite de bloquer sur cette fonction en cas du'un soucis d'algo
      console.error('focusNextInput recursivity error');
      return;
    }
    const lastLineFocus = this.getLineDecFromArrayByIdLigne(this.mLastIdLineSelected.toString());
    if (!lastLineFocus)
      return;
    const arrayOfInput = this.getArrayOfInputForOneLine(lastLineFocus); // On recupere tout les inputs disponible pour la ligne en cours

    // Gestion des evenement de l'input actuel avant de focus le suivant
    if (nbRecall == 0) {  // Evite les appel multiple car fonction recursif
      if (document.activeElement instanceof HTMLInputElement) {
        const infoActiveElement = this.getInfoFromInputMeasure(document.activeElement);
        if (infoActiveElement.type) {
          if (infoActiveElement.colName == this.HTML_ANALYSIS_COL.Diameter) {
            console.log('On est en train de focus le diametre');

            //(document.activeElement as unknown as MatAutocompleteTrigger).closePanel();
          }
        }
      }
      if (document.activeElement?.id == this.getHtmlInputWithColnameNoline(this.HTML_ANALYSIS_COL.IdShape, this.mLastIdLineSelected)) {
        // On a le focus sur la ligne de saisie de code forme
        if (lastLineFocus.mCodeF == g_params.shapeCode99) {
          await this.openShape99(lastLineFocus);
        }
      }
    }

    // Verification si le prochain input exist
    if (arrayOfInput.length > (this.mLastNbInputFocused + 1)) {
      this.mLastNbInputFocused++; // On incrémente le nb d'input focus sur cette ligne
      const nextInput = arrayOfInput[this.mLastNbInputFocused]; // On recupere le prochain input de la ligne en cours
      // On verifie que l'on peut acceder au prochain input
      if (nextInput.readOnly) {           // Si le prochain input est en readOnly (impossible d'écrire dessus)
        this.focusNextInput((nbRecall + 1));  // On relance la fonction pour focus le prochain input
      } else if ( // Si le prochain input correspond au colone de cote du BS
          nextInput.id == this.getHtmlInputWithColnameNoline(this.HTML_ANALYSIS_COL.A, this.mLastIdLineSelected) ||
          nextInput.id == this.getHtmlInputWithColnameNoline(this.HTML_ANALYSIS_COL.B, this.mLastIdLineSelected) ||
          nextInput.id == this.getHtmlInputWithColnameNoline(this.HTML_ANALYSIS_COL.C, this.mLastIdLineSelected) ||
          nextInput.id == this.getHtmlInputWithColnameNoline(this.HTML_ANALYSIS_COL.D, this.mLastIdLineSelected) ||
          nextInput.id == this.getHtmlInputWithColnameNoline(this.HTML_ANALYSIS_COL.E_R, this.mLastIdLineSelected)
      ) {
        // On verifie si on peut saisir la cote X (disponible & cote writable)
        let idArmaShapeMeasure;
        //let arrayInput = lastLineFocus.mArrayInput;
        if (nextInput.id == this.getHtmlInputWithColnameNoline(this.HTML_ANALYSIS_COL.A, this.mLastIdLineSelected))        idArmaShapeMeasure = 0;
        else if (nextInput.id == this.getHtmlInputWithColnameNoline(this.HTML_ANALYSIS_COL.B, this.mLastIdLineSelected))   idArmaShapeMeasure = 1;
        else if (nextInput.id == this.getHtmlInputWithColnameNoline(this.HTML_ANALYSIS_COL.C, this.mLastIdLineSelected))   idArmaShapeMeasure = 2;
        else if (nextInput.id == this.getHtmlInputWithColnameNoline(this.HTML_ANALYSIS_COL.D, this.mLastIdLineSelected))   idArmaShapeMeasure = 3;
        else if (nextInput.id == this.getHtmlInputWithColnameNoline(this.HTML_ANALYSIS_COL.E_R, this.mLastIdLineSelected)) idArmaShapeMeasure = 4;
        let found = false;
        for (let i = 0 ; i < arrayOfInput.length - 1 ; i++) {
          if ((!arrayOfInput[i].readOnly) && (arrayOfInput[i].id == ArmaShapeUtilit.getHTMLInputMeasure(this.mLastIdLineSelected, idArmaShapeMeasure))) {
            nextInput.focus();
            found = true;
            break;
          }
        }
        if (!found) {
          this.focusNextInput((nbRecall + 1));  // On focus le prochain input
        }
      } else if (
        nextInput.id == 'measure-' + this.mLastIdLineSelected + '-0' ||
        nextInput.id == 'measure-' + this.mLastIdLineSelected + '-1' ||
        nextInput.id == 'measure-' + this.mLastIdLineSelected + '-2' ||
        nextInput.id == 'measure-' + this.mLastIdLineSelected + '-3' ||
        nextInput.id == 'measure-' + this.mLastIdLineSelected + '-4'
      ) { // Si le prochain input correspond au premiere cote de la forme
        if (this.mInputType == 'BS 4466 / 8666') { // & que l'on à l'affichage type BS

          if (
            (document.activeElement?.id == ArmaShapeUtilit.getHTMLInputMeasure(this.mLastIdLineSelected, 0 ) && (nextInput.id == ArmaShapeUtilit.getHTMLInputMeasure(this.mLastIdLineSelected, 1))) ||
            (document.activeElement?.id == ArmaShapeUtilit.getHTMLInputMeasure(this.mLastIdLineSelected, 1 ) && (nextInput.id == ArmaShapeUtilit.getHTMLInputMeasure(this.mLastIdLineSelected, 2))) ||
            (document.activeElement?.id == ArmaShapeUtilit.getHTMLInputMeasure(this.mLastIdLineSelected, 2 ) && (nextInput.id == ArmaShapeUtilit.getHTMLInputMeasure(this.mLastIdLineSelected, 3))) ||
            (document.activeElement?.id == ArmaShapeUtilit.getHTMLInputMeasure(this.mLastIdLineSelected, 3 ) && (nextInput.id == ArmaShapeUtilit.getHTMLInputMeasure(this.mLastIdLineSelected, 4))) ||
            (document.activeElement?.id == ArmaShapeUtilit.getHTMLInputMeasure(this.mLastIdLineSelected, 4 ) && (nextInput.id == ArmaShapeUtilit.getHTMLInputMeasure(this.mLastIdLineSelected, 5)))
          ) {
            // Quand on est dans l'input type BS et que l'on en actuelement en focus une input de la colone du schema
            // On continue le fonctionement basic en focusant le prochain input
            nextInput.focus();
          } else {
            // Si on est sur une imput que l'on peut déja remplir sur une colone avec l'affichage type 'BS 4466 / 8666'
            // Alors on ne focus pas & on prend le prochain input
            this.focusNextInput((nbRecall + 1));
          }
        } else {
          nextInput.focus();
        }
      } else if (nextInput.id == this.getHtmlInputWithColnameNoline(this.HTML_ANALYSIS_COL.Comment, this.mLastIdLineSelected)) { // Si on est sur l'input de la saisie du petit commentaire
        // On ne fait pas de focus & on cherche le prochain input
        this.focusNextInput((nbRecall + 1));
      } else {  // Si aucun des cas plus haut on peut focus l'input
        nextInput.focus();
      }
    } else {
      // Si on est sur le dernier imput on focus la prochaine ligne
      this.mLastNbInputFocused = 0;
      this.mLastIdLineSelected = (+lastLineFocus.mNoLine) + 1;
      const nextLine = this.getLineDecFromArrayByIdLigne(((+lastLineFocus.mNoLine) + 1).toString());
      if (!nextLine)
        return;
      const arrayOfInputNextLine = this.getArrayOfInputForOneLine(nextLine);
      while ((arrayOfInputNextLine[this.mLastNbInputFocused].disabled || arrayOfInputNextLine[this.mLastNbInputFocused].readOnly) &&
              this.mLastNbInputFocused < arrayOfInputNextLine.length - 1)
        this.mLastNbInputFocused++;
      arrayOfInputNextLine[this.mLastNbInputFocused].focus();
      // On focus le premier input de la prochaine ligne
    }
  }

  private focusUpInput() {
    if (document.activeElement instanceof HTMLInputElement) {
      const infoLine = this.getInfoLineFromInput(document.activeElement);
      if (infoLine.inputType == 'input' && infoLine.colName == this.HTML_ANALYSIS_COL.Diameter)
        return;
    }
    const upLine = this.getLineDecFromArrayByIdLigne((this.mLastIdLineSelected - 1).toString());
    if (upLine) {
      if (+upLine.mNoLine == 1) {
        CUtilit.scrollDocumentToTop(document.getElementById('decorticage-content'));
      }
      const arrayOfInput = this.getArrayOfInputForOneLine(upLine);
      this.mLastNbInputFocused = 0;
      if (arrayOfInput.length > 0) {
        arrayOfInput[this.mLastNbInputFocused].focus();
      }
    }
  }

  private focusDownInput() {
    if (document.activeElement instanceof HTMLInputElement) {
      const infoLine = this.getInfoLineFromInput(document.activeElement);
      if (infoLine.inputType == 'input' && infoLine.colName == this.HTML_ANALYSIS_COL.Diameter)
        return;
    }
    const downLine = this.getLineDecFromArrayByIdLigne(((+this.mLastIdLineSelected) + 1).toString());
    if (downLine) {
      const arrayOfInput = this.getArrayOfInputForOneLine(downLine);
      this.mLastNbInputFocused = 0;
      if (arrayOfInput.length > 0) {
        arrayOfInput[this.mLastNbInputFocused].focus();
      }
    }
  }

  getArrayOfInputForOneLine(line: CLineDec): HTMLInputElement[] {
    const templateLineAna = 'ana-line-' + line.mNoLine;
    const element = document.getElementById(templateLineAna);
    let arrayOfInputElement: HTMLInputElement[] = [];
    if (element instanceof HTMLElement)
      arrayOfInputElement = CUtilit.findInputsInHtmlElement(element);
    else
      console.warn('html associé a la ligne non trouvée (' + templateLineAna + ')');
    return arrayOfInputElement;
  }

  /**
   * Quand l'utilisateur saisie une touche sur l'écriture du code forme
   * @param element see CLineDec
   */
  onCodeFormeChange(element: CLineDec, newStr: string) {
    if (!element) return;
    element.mCodeF = newStr.toUpperCase();
    element.clearCotation();
    element.clearIdLine();
  }

  closeAnalysis() {
    this.dataSource.data = [];
    this.dataProduct.data = [];
    this.matTablearrayLineDec?.renderRows();
    this.matTableArrayProduct?.renderRows();
  }

  /**
   * Appeler dans le HTML
   * Verifie si le diametre donnée est bon ou non
   *  - Si le diametre est bon enregistre la nuance par defaut
   *  - Si le diametre est incorect efface la nuance de la ligne
   *  - Aucune modif est faite sur la nuance si elle est déja donné exception pour le cas ou le diametre est incorecte
   * @param ligne ligne du décorticage
   */
  async checkDiam(ligne: CLineDec) {
    event?.stopPropagation();    // On ne fait pas l'execution de la ligne car elle va aussi remplasser le grade
    // Check si on à un diameter de saisie
    if (ligne.mDiamNum == '') {
      console.log('No diam inputed');
      return;
    }

    // Pour executer ce code sans passer par une requete get....
    // Connaitre le grade qui va etre utiliser sur la machine ?
    // Verification de l'existance du diametre
    const checkGradeResult = GradeManager.getGradeFromDiam(+ligne.mDiamNum, this.mGradeManager.GetArrayGrade());
    // Si diamexiste & que la nuance n'est pas remplis
    if (checkGradeResult.found) {
      if (!ligne.mDiamGrade) {
        ligne.mDiamGrade = checkGradeResult.gradeCode;
      }
      console.log('diametre existe');
    } else {
      // Si le diam n'est pas valide on enleve l'info du grade
      ligne.mDiamGrade = '';
      console.log('diametre n\'existe pas');
    }
    this.refreshLineArmaServ(ligne);  // On fait le refresh de la ligne apres avoir recu les nouvelle information de la ligne
  }

  //Clic sur le bouton ajout de répartition
  onDrawerInputRepartitionClick() {
    if (!this.mLastIdLineSelected || this.mLastIdLineSelected == 0) this.onColFocus(undefined, 1);
    const selectedLine: CLineDec | null = this.getSelectedLine();
    if ((selectedLine != null) && selectedLine.isEmpty()) {
      selectedLine.mRepartition = '';
      // On attends que le DOM ait ajouté les inputs à la page HTML
      // On focus la zone de répartition de la nouvelle ligne de répartition
      setTimeout(() => {
        const arrayInput = this.getArrayOfInputForOneLine(selectedLine);
        for (let i = 0; i < arrayInput.length; i++) {
          const infoLine = this.getInfoLineFromInput(arrayInput[i]);
          if (infoLine.inputType == 'input' && infoLine.colName == this.HTML_ANALYSIS_COL.Distribution) {
            arrayInput[i].focus();
            break;
          }
        }
      });
    }
  }

  onDrawerShapeClick(forme: Formes) {
    // Si on à pas séléctionné de ligne on passe sur la premiere ligne
    if (!this.mLastIdLineSelected || this.mLastIdLineSelected == 0) this.onColFocus(undefined, 1);
    // Si on est sur une répartition on ne fait rien
    if (this.dataSource.data[this.mLastIdLineSelected - 1].isARepartition())
      return;
    // On affecte le code forme voulue sur la ligne
    this.dataSource.data[this.mLastIdLineSelected - 1].mCodeF = forme.CodeForme;
    // On vide les cotes saisies
    this.dataSource.data[this.mLastIdLineSelected - 1].mArrayCote = [];
    // On peut aussi se permetre d'effacer les informations de pods
    this.dataSource.data[this.mLastIdLineSelected - 1].clearCotation();
    // On pointe sur la premier cote de la forme en cours
    // On fait un setTimeout pour attendre que le DOM ajoute les input à la page
    setTimeout(() => {
      // On recuperer le nombre d'input disponible sur la page
      const selectedLine = this.getSelectedLine();
      if (!selectedLine)
        return;
      const arrayInput = this.getArrayOfInputForOneLine(selectedLine);
      for (let i = 0 ; i < arrayInput.length ; i++) {
        const infoLine = this.getInfoLineFromInput(arrayInput[i]);
        if (infoLine.inputType == 'measure' && infoLine.idMeasure == 0) {
          // Le premiere cote doit toujours etre écrite, donc pas de verification du type d'input
          arrayInput[i].focus();
          break;
        }
        if (i == arrayInput.length - 1) // Pas quiter le break signifie que l'on a pas reussi a trouver l'input, ne devrais pas arriver
          console.warn('Impossible de focus le premier input de la forme');
      }
    });
  }

  public async onMeshClick() {
    if (this.mLastIdLineSelected === undefined) {
      alert('Please select a line');
      return;
    }
    // Recuperation de la ligne en cours
    const lineDec: CLineDec | null = this.getLineDecFromArrayByIdLigne(this.mLastIdLineSelected ? this.mLastIdLineSelected.toString() : '1');
    if (lineDec == null)
      return;
    //TODO: Message de confirmation pour remplacer la ligne par une ligne wmesh

    // On ouvre la fenetre de saisie de mesh
    const result: CLineDec|boolean = await DialogSpecialMesh.openDialog(this.mDialog, lineDec, this.mGradeManager.GetArrayGrade());

    // Mise à jour de la ligne avec les infos du wmesh
    if (result instanceof CLineDec) {
      lineDec.update(result);
      //FIXME: Checker le diametre ?
      this.onValueLineChange(lineDec);
    }
  }

  /**
   * Retrouve le CLineDec du tableau de décorticage à partir de l'numéro de ligne du tableau
   * @param noLine numéro de la ligne
   */
  getLineDecFromArrayByIdLigne(noLine: string): CLineDec | null {
    // Sur armaor la premiere ligne commence à 1
    if (noLine == '0')
      return null;
    const tempArray = this.dataSource.data[+noLine - 1];
    if (tempArray && (tempArray.mNoLine == noLine)) {
      return this.dataSource.data[+noLine - 1];
    } else {
      for (let i = 0; i < this.dataSource.data.length; i++) {
        if (this.dataSource.data[i].mNoLine == noLine) {
          return this.dataSource.data[i];
        }
      }
    }
    console.warn('Impossible de recuperer la ligne n' + noLine);
    return null;
  }

  async onDblClick(lineDec: CLineDec) {
    if (this.isReadOnlyOrLock) return true; // On stop si on est en lecture seule ou lock
    if (lineDec.mCodeF == g_params.shapeCode99) {
      await this.openShape99(lineDec);
    } else if (lineDec.isAWMesh) {
      await this.onMeshClick();
    }
  }

  public getSelectedLine(): CLineDec | null {
    if (this.mLastIdLineSelected == null)
      return null;
    return this.getLineDecFromArrayByIdLigne(this.mLastIdLineSelected.toString());
  }

  HTML_copyLine() {
    const selectedLine = this.getSelectedLine();
    if (selectedLine != null && selectedLine) {
      this.lineCopied = selectedLine.toJsLineDec(false);
    }
  }

  HTML_pasteLine() {
    const selectedLine = this.getSelectedLine();
    if (selectedLine != null && selectedLine && this.lineCopied) {
      const idLine = selectedLine.mNoLine;
      selectedLine.loadFromjsLineDec(this.lineCopied, false, false);
      selectedLine.mNoLine = idLine;
      this.onValueLineChange(selectedLine);
    }
  }

  HTML_CanInsertLine(): boolean {
    return this.mLastIdLineSelected > 1;
  }

  HTML_InsertLine() {
    const newLineDec = new CLineDec();
    const numLine = this.mLastIdLineSelected;
    newLineDec.mNoLine = numLine.toString();
    for (let i = numLine - 1 ; i < this.dataSource.data.length ; i++) {
      const line: CLineDec = this.dataSource.data[i];
      // tslint:disable-next-line:radix TODO
      line.mNoLine = (parseInt(line.mNoLine) + 1).toString();
    }
    this.dataSource.data.splice(this.mLastIdLineSelected - 1, 0, newLineDec);
    this.matTablearrayLineDec?.renderRows();
    this.dataSource._updateChangeSubscription();

    // On ajoute quand même une ligne
    this.ajouterLigneDec();
    this.dataSource.data.splice(this.mLastIdLineSelected, 0, );
    this.matTablearrayLineDec?.renderRows();
  }

  HTML_DeleteLine() {
    const lines = (this.mMenuOverProduct ? this.dataProduct.data : this.dataSource.data);
    const lastIdLine: number = (this.mMenuOverProduct ? this.mLastIdLineProductSelected : this.mLastIdLineSelected);
    this.HTML_eraseSelectedLine();
    lines.splice(lastIdLine - 1, 1);
    for (let i = lastIdLine - 1 ; i < lines.length ; i++) {
      const line = lines[i];
      if (line instanceof CLineDec) {
        // tslint:disable-next-line:radix
        line.mNoLine = (parseInt(line.mNoLine) - 1).toString();
      } else if (line instanceof CProduct) {
        line.mNoLine = line.mNoLine - 1;
      } else {
        console.log(line);
      }
    }
    if (this.mMenuOverProduct) {
      this.matTableArrayProduct?.renderRows();
      this.dataProduct._updateChangeSubscription();
    } else {
      this.matTablearrayLineDec?.renderRows();
      this.dataSource._updateChangeSubscription();
    }
    this.calcAnalysisWeight();
    this.calcProductWeight();
  }

  HTML_eraseSelectedLine() {
    const selectedLine = this.getSelectedLine();
    if (selectedLine != null && selectedLine) {
      selectedLine.clearLine(false);
      this.onValueLineChange(selectedLine);
    }
  }

  /**
   * Rafraichi la ligne de décorticage en l'envoyant sur le serveur rest & recupere une ligne avec les poids de calculer
   * TODO: ? Faire pareil avec la machine a utiliser a l'usine pour permetre un enregistrement sans erreur ?
   * @param currentLine ??
   */
  async refreshLineArmaServ(currentLine: CLineDec) {
    if (!currentLine.isEmpty()) {
      const error = currentLine.isLineValide(false, this.arrayShape, this.mGradeManager.GetArrayDiameter());
      if (error != '')
        console.warn(error, currentLine);
      else
        await currentLine.refreshLineArmaWeb(this.http, this.arrayShape);
    }
  }

  HTML_isLineValide(element: CLineDec): boolean {
    return element.isLineValide(true, this.arrayShape, this.mGradeManager.GetArrayDiameter()) == '';
  }

  onOrderInfoKeyPress(event: KeyboardEvent) {
    try {
      const idElement = (<HTMLElement>event.target).id;
      if (event && event.key == 'Enter') {
        event.preventDefault();
        switch (idElement) {
          case 'id-designation':
            document.getElementById('id-numplan')?.focus();
            break;
          case 'id-numplan':
            document.getElementById('in-various')?.focus();
            break;
          case 'in-various':
            document.getElementById('in-cust-ref')?.focus();
            break;
          case 'in-cust-ref':
            // On focus la premiere ligne du décorticage
            const firstLine = this.getLineDecFromArrayByIdLigne('1');
            if (firstLine) {
              const arrayInput = this.getArrayOfInputForOneLine(firstLine);
              arrayInput[0].focus();
            }
            break;
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  blockTextEvent(event: KeyboardEvent) {
    if (event) {
      switch (event.key) {
        case 'Enter':
          event.preventDefault();
          break;
      }
    }
  }

  /**
   * Bloque la saisie si on tape autre chose qu'un chiffre
   * à utiliser avec l'emitter keyPress
   * @param event evenement du keypress
   */
  keyPressOnlyNumber(event: KeyboardEvent) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  /**
   * Bloque la saisie si on tape autre chose qu'un chiffre (accepte les virgules et points)
   * à utiliser avec l'emitter keyPress
   * @param event evenement du keypress
   */
  keyPressOnlyNumberFloat(event: KeyboardEvent) {
    const charCode = (event.which) ? event.which : event.keyCode;
    //Si c'est un chiffre OU ',' OU '.'
    return ((charCode >= 48 && charCode <= 57) || (charCode == 44 || charCode == 46));
  }

  /**
   * Vide et reprend le focus de l'input si la saisie ne autre chose que de chiffre
   * @param eventTarget ??
   */
  focusOutCheckNumberOrClear(eventTarget: EventTarget) {
    if (eventTarget instanceof HTMLInputElement) {
      if (isNaN(+eventTarget.value)) {
        eventTarget.value = '';
        eventTarget.focus();
      }
    }
  }

  /**
   * Pour les input des cote de la forme
   * @param element ??
   * @param cotation ??
   */
  generateCSSInputMeasure(element: CLineDec, cotation: IInputCotation, indexCote: number) {
    const css: any = {};
    if (document.activeElement instanceof HTMLInputElement) { // On check si on à le focus sur un input
      if (document.activeElement.id) {  // On check si l'input à un ID
        const colIdLine = this.getInfoLineFromInput(document.activeElement); // On tente de recuperer le contenu de l'id
        if (colIdLine && colIdLine.idLine == +element.mNoLine) {
          if (
            (colIdLine.colName == this.HTML_ANALYSIS_COL.A && indexCote == 0) ||
            (colIdLine.colName == this.HTML_ANALYSIS_COL.B && indexCote == 1) ||
            (colIdLine.colName == this.HTML_ANALYSIS_COL.C && indexCote == 2) ||
            (colIdLine.colName == this.HTML_ANALYSIS_COL.D && indexCote == 3) ||
            (colIdLine.colName == this.HTML_ANALYSIS_COL.E_R && indexCote == 4)
          ) {
            css['background-color'] = 'green';
          }
        }
      }
    }
    // Remplisage du CSS
    css.left = cotation.X + 'px';
    css.top = cotation.Y + 'px';
    css.height = cotation.Height + 'px';
    css.width = cotation.Width + 'px';
    css['border-color'] = element.mArrayCote[cotation.Id] ? 'rgb(85, 85, 85, 0)' : 'rgb(85, 85, 85)';
    css['font-size'] = '12px';

    return css;
  }

  /**
   * Calcul le poids total du décorticage en cours & le retourne, affect aussi la variable HTML_AnalysisWeight
   */
  calcAnalysisWeight(): number {
    let weight = 0;
    this.dataSource.data.forEach(value => {
      const lineWeight = +value.getWeight();
      if (lineWeight) weight += lineWeight;
    });
    weight = +weight.toFixed(2);  // Soucis poids qui me donne es nombre dépassant le millieme
    this.HTML_AnalysisWeight = weight;
    return this.HTML_AnalysisWeight;
  }

  /**
   * Calcule le poids de tout les produits
   */
  calcProductWeight(): number {
    let weight = 0;
    this.dataProduct.data.forEach(value => {
      const lineWeight = value.totalWeight;
      if (lineWeight) weight += lineWeight;
    });
    this.HTML_ProductWeight = weight;
    return this.HTML_ProductWeight;
  }

  public getFormeFromCatalogue(codeForme: any): Formes | undefined {
    return CUtilit.findShape(codeForme, this.arrayShape);
  }

  public getHighlightMeasureId(idLine: any): number {
    let result = -1;
    if (this.mLastIdLineSelected == idLine) {
      const activeElement = document.activeElement;
      if (activeElement instanceof HTMLInputElement) {
        switch (activeElement.id) {
          case this.getHtmlInputWithColnameNoline(this.HTML_ANALYSIS_COL.A, this.mLastIdLineSelected):   result = 0; break;
          case this.getHtmlInputWithColnameNoline(this.HTML_ANALYSIS_COL.B, this.mLastIdLineSelected):   result = 1; break;
          case this.getHtmlInputWithColnameNoline(this.HTML_ANALYSIS_COL.C, this.mLastIdLineSelected):   result = 2; break;
          case this.getHtmlInputWithColnameNoline(this.HTML_ANALYSIS_COL.D, this.mLastIdLineSelected):   result = 3; break;
          case this.getHtmlInputWithColnameNoline(this.HTML_ANALYSIS_COL.E_R, this.mLastIdLineSelected): result = 4; break;
        }
      }
    }
    return result;
  }

  /**
   * Retourne le contenu attendu du param ngClass sur une ligne du décorticage
   * @param line ligne en cours
   */
  public getNGClassLine(line: CLineDec | CProduct): any {
    let selectedLine = false;
    let errorLine = false;
    if (line instanceof CProduct) {
      selectedLine = +line.mNoLine == this.mLastIdLineProductSelected;
    } else if (line instanceof CLineDec) {
      selectedLine = +line.mNoLine == this.mLastIdLineSelected;
      errorLine = (line as CLineDec).isLineValide(true, this.arrayShape, this.mGradeManager.GetArrayDiameter()) != '';
    }
    return {
      'ana-line':             !errorLine && !selectedLine,
      'selectedLine':         !errorLine && selectedLine,
      'error-line':           errorLine  && !selectedLine,
      'error-selected-line':  errorLine  && selectedLine
    };
  }

  /**
   * Garde quand même une ligne vide pour continuer a écrire dans le déco
   * Appeler dans le HTML
   */
  public removeEmptyLine() {
    let i = this.dataSource.data.length - 1;
    while (i >= 0) {
      if (this.dataSource.data[i].isEmpty()) {
        this.dataSource.data.splice(i, 1);
      }
      i--;
    }
    // On ajoute quand même une ligne
    this.ajouterLigneDec();
    this.matTablearrayLineDec?.renderRows();
  }

  /**
   * Engresitre le status du panel
   * @param object MatExpansionPanel
   */
  public onPanelOrderInfoStateChange(object: MatExpansionPanel) {
    if (object === this.mPanelInfoIOrder) {
      this.mPanelOrderInfoOpenState = object.expanded;
      localStorage.setItem(LOCAL_STORAGE_ORDER_PANEL_STATE, object.expanded ? '1' : '0');
    } else if (object == this.mPanelAnalysis) {
      if (object.expanded)
        this.mPanelProduct?.close();
    } else if (object == this.mPanelProduct) {
      if (object.expanded)
        this.mPanelAnalysis?.close();
    }
  }

  /**
   * @param element ??
   * @param idCote ??
   * @returns True pour verouiller l'input sinon false
   */
  public isCoteLocked(element: CLineDec, idCote: number): boolean {
    return element.isCoteLocked(this.arrayShape, idCote);
  }

  /**
   * @returns undefined si le deco n'est pas chargé sinon return le tableau de forme associé au décorticage
   */
  public getArrayShapeAvailable(): undefined|Formes[] {
    return this.arrayShape;
  }

  /**
   * Retourne les collone à afficher pour le décorticage
   */
  get displayedColumns(): string[] {
    const result: string[] = [];
    const userParam = CUtilit.loadOrInitUserParam();
    this.mInputType = userParam.AnalysisInputType;
    result.push(this.HTML_ANALYSIS_COL.IdLine);
    if (userParam.ShowMemberColumn)
      result.push(this.HTML_ANALYSIS_COL.Membername);
    if (userParam.AnalysisInputType == 'BS 4466 / 8666') {
      result.push(
        this.HTML_ANALYSIS_COL.Barmark,
        this.HTML_ANALYSIS_COL.Qty,
        this.HTML_ANALYSIS_COL.Diameter,
        this.HTML_ANALYSIS_COL.Grade,
        this.HTML_ANALYSIS_COL.Length,
        this.HTML_ANALYSIS_COL.IdShape,
        this.HTML_ANALYSIS_COL.A,
        this.HTML_ANALYSIS_COL.B,
        this.HTML_ANALYSIS_COL.C,
        this.HTML_ANALYSIS_COL.D,
        this.HTML_ANALYSIS_COL.E_R
      );
    } else {
      result.push(
        this.HTML_ANALYSIS_COL.Length,
        this.HTML_ANALYSIS_COL.Barmark,
        this.HTML_ANALYSIS_COL.Qty,
        this.HTML_ANALYSIS_COL.Diameter,
        this.HTML_ANALYSIS_COL.Grade,
        this.HTML_ANALYSIS_COL.IdShape
      );
    }
    result.push(this.HTML_ANALYSIS_COL.Schema);
    if (!userParam.AnalysisHideComment)
      result.push(this.HTML_ANALYSIS_COL.Comment);
    result.push(
      this.HTML_ANALYSIS_COL.Weight,
      this.HTML_ANALYSIS_COL.RealShapeDrawing
    );
    return result;
  }

  get displayedProductColumns(): string[] {
    return [
      this.HTML_PRODUCT_COL.IdLine,
      this.HTML_PRODUCT_COL.ProductLabel,
      this.HTML_PRODUCT_COL.Qty,
      this.HTML_PRODUCT_COL.Unit,
      this.HTML_PRODUCT_COL.Weight
    ];
  }

  set lockAnalysis(val: boolean) {
    this.HTML_LockAnalysis = val;
  }

  get isAnalysisLocked(): boolean {
    return this.HTML_LockAnalysis;
  }

  get askToSave(): boolean {
    return this.mAskToSave;
  }

  set askToSave(val: boolean) {
    this.mAskToSave = val;
  }

  public get HTML_ReadOnlyAnalysis(): boolean {
    return this.mReadOnlyAnalysis;
  }

  public get isReadOnlyOrLock(): boolean {
    return this.HTML_ReadOnlyAnalysis || this.HTML_LockAnalysis;
  }

  public isContextMenuVisible(contextMenu: string): boolean {
    switch (contextMenu) {
      case 'copy':
      case 'paste':
      case 'insert':
      case 'erase':
      case 'removeEmpty':
        return !this.mMenuOverProduct;
      default: return true;
    }
  }

  public GetAvailableGrades(line: CLineDec): Grade[] {
    return this.mGradeManager.GetArrayGrade(+line.mDiamNum);
  }

  public GetAvailableDiameters(line: CLineDec): String[] {
    return this.mGradeManager.GetArrayDiameter(line.mDiamGrade);
  }

  /**
   * Specifique pour les colones du décorticage
   * @param line ligne en cours
   * @param column collone du tableau sur lesquel on check l'input
   * @returns ??
   */
  public isReadOnlyOrLockCol(line?: CLineDec|CProduct|null, column?: string): boolean {
    // On ne fait rien si le deco est lock ou en lecture seule
    let disabled = false;
    if (this.isReadOnlyOrLock || line == null) // Cas lock ou line null
      disabled = true;
    else if (line instanceof CProduct) { // Cas CProduct
      disabled = this.isReadOnlyOrLock;
    } else if (line instanceof CLineDec) { // Cas CLineDec
      if (line.isARepartition())
        disabled = column != this.HTML_ANALYSIS_COL.Schema;
    } else
      console.warn('isReadOnlyOrLockCol object line unknown : ', line);
    return disabled;
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  public onSiteCodeChange(event: string) {
    console.log('onSiteCodeChange: event: ' + event);
    let factoryCode = 0;
    g_params.g_arraySite.forEach(site => {
      if (site.CODECHANTIER == event)
        factoryCode = site.DEFAULT_FACTORY;
    });
    this.mArmaDatePicker.loadNoOpenDay(factoryCode);
  }

  public startWith(value: 'steel'|'prod') {
    console.log('OK');
    this.mPanelProduct.close();
    this.mPanelAnalysis.close();
    this.mPanelInfoIOrder.close();

    if (value == 'steel') {
      // On ouvre le paneau des acier
      // On ajoute une ligne de deco
      this.ajouterLigneDec();
      this.mPanelAnalysis.open();
    } else {
      // On ouvre le paneau des produits
      // On ouvre le modal de selection de produit
      this.openProductInput();
      this.mPanelProduct.open();
    }
  }

  public noEnterTextArea(event: KeyboardEvent) {
    if (event.key == 'Enter')
      event.preventDefault();
    event.stopImmediatePropagation();
  }

  public onBtnContactClick() {
    DialogListContactComponent.openDialog(this.mDialog, this.mTabSiteSelection.HTML_SelectSiteCode).then(newContact => {
      if (!newContact)
        return;
      this.contactInformation = newContact;
    });
  }

  public onBtnContactRemove() {
    this.contactInformation = undefined;
  }

  public onBtnNoteClick() {
    DialogOrderNoteComponent.displayDialog(this.mDialog, this.mOrderNote, this.isReadOnlyOrLock).afterClosed().toPromise().then(value => {
      if (value != undefined)
        this.mOrderNote = value;
    });
  }

  get displayPanelAnalysis(): boolean {
    return (this.dataSource.data.length > 0) || g_params.inputSteelAndProduct;
  }

  get displayPanelProduct(): boolean {
    return (this.dataProduct.data.length > 0) || g_params.inputSteelAndProduct;
  }

  get showBtnAddProductOrSteel(): boolean  {
    if (this.isReadOnlyOrLock)
      return false;
    return ( !this.displayPanelAnalysis && !this.displayPanelProduct);
  }

  public asLineDec(val: any): CLineDec {
    return val as CLineDec;
  }

  public asProduct(val: any): CProduct {
    return val as CProduct;
  }

  get isCustomerRefValid(): boolean {
    return this.HTML_ReadOnlyAnalysis || (this.mInputCustRef?.nativeElement?.value?.length > 0 ?? false);
  }

  get isContactValid(): boolean {
    return this.HTML_ReadOnlyAnalysis || (this.contactInformation?.Id != null);
  }

  get isDeliveryDateValid(): boolean {
    //return !!this.mArmaDatePicker.valueInput;
    return this.HTML_ReadOnlyAnalysis || this.mArmaDatePicker.isValidDate;
  }

  get isHeaderValid(): boolean {
    return this.isCustomerRefValid && this.isDeliveryDateValid && this.isContactValid;
  }

  get steelListValidity(): SteelListValidity {
    return {
      NoDeliveryDate: !this.isDeliveryDateValid,
      NoCustomerRef: !this.isCustomerRefValid,
      NoContact: !this.isContactValid
    };
  }

  get nbLockAfterToday(): number {
    return g_params.minOpenDateBetweenCreateAndDelivery;
  }
}

class UtilitRealShapeDrawing {

  private static readonly TIMEOUT_DURATION = 1000;
  private static readonly SHAPE_WIDTH = 500;
  private static readonly SHAPE_HEIGHT = 300;
  private static readonly XY_MOUSE_DISPLACEMENT = 1;

  private mImageRef?: HTMLImageElement = undefined;
  private mCanvasRef?: HTMLCanvasElement = undefined;
  private mSafeUrlFromServer?: SafeUrl = undefined;
  private mCurrentNoLine: number = -1;
  private mTimeoutId?: any;

  constructor(private mHttp: HttpClient,
              private mDomSanitizer: DomSanitizer,
              private mArmaServMethods: ArmaServServerMethods) { }

  public razImage() {
    this.mSafeUrlFromServer = undefined;
    this.mCurrentNoLine = -1;
  }

  public startDelayDisplayRealShapeDrawing(event: MouseEvent,
                                           element: CLineDec,
                                           arrayShapeAvailable: Formes[],
                                           arrayDiameter: string[]) {
    //console.log(`startDelayDisplayRealShapeDrawing image ref src:${this.mImageRef.src} url:${this.mSafeUrlFromServer}`);
    this.updatePoseRealShapeDrawing(event);
    // On réaffiche l'image
    if (this.isSameLine(element) && this.hasUrl) {
      this.displayImg();
    } else if (!this.hasUrl || !this.isSameLine(element)) { // Pas la même ligne
      if (element.isEmpty() || element.isLineValide(false, arrayShapeAvailable, arrayDiameter) !== '') // Ligne invalide
        return;
      console.log(`Updating image in ${UtilitRealShapeDrawing.TIMEOUT_DURATION}ms`);
      this.hideImg();
      if (element.isAWMesh) {
        if (this.mCanvasRef && element.wMeshInformation && element.wMeshInformation) {
          CUtilForme.clearCanvas(this.mCanvasRef);
          this.mCanvasRef.height = UtilitRealShapeDrawing.SHAPE_HEIGHT;
          this.mCanvasRef.width = UtilitRealShapeDrawing.SHAPE_WIDTH;
          WMeshUtils.drawMesh(this.mCanvasRef, element.wMeshInformation.vertical, element.wMeshInformation.horizontal, false, '', true);
          // On récupère l'image en URL depuis le canvas
          this.mSafeUrlFromServer = this.mCanvasRef.toDataURL();
          this.displayImg();
        }
        this.mCurrentNoLine = +element.mNoLine;
      } else {
        this.mCurrentNoLine = +element.mNoLine;
        this.mTimeoutId = setTimeout(this.displayRealShapeDrawing.bind(
          this,
          event,
          element
        ), UtilitRealShapeDrawing.TIMEOUT_DURATION);
      }
    }
  }

  public cancelDisplayRealShapeDrawing() {
    clearTimeout(this.mTimeoutId);
    this.hideImg();
  }

  public displayImg() {
    if (this.mImageRef)
      this.mImageRef.style.display = 'unset';
  }

  public hideImg() {
    if (this.mImageRef)
      this.mImageRef.style.display = 'none';
  }

  public displayRealShapeDrawing(event: MouseEvent, element: CLineDec) {
    let promise: Promise<SafeUrl>;
    if (element.isAWMesh) {
      promise = this.mArmaServMethods.getImageMesh(element, UtilitRealShapeDrawing.SHAPE_WIDTH, UtilitRealShapeDrawing.SHAPE_HEIGHT);
    } else {
      promise = this.mArmaServMethods.getDrawingShape(element, UtilitRealShapeDrawing.SHAPE_WIDTH, UtilitRealShapeDrawing.SHAPE_HEIGHT);
    }
    promise.then(url => {
      this.mSafeUrlFromServer = url;
      this.mSafeUrlFromServer
      this.displayImg();
    }).catch(e => {
      this.mSafeUrlFromServer = undefined;
      console.error(e);
    });
  }

  public updatePoseRealShapeDrawing(event: MouseEvent) {

    const shapeRect = {
      left: event.x - UtilitRealShapeDrawing.SHAPE_WIDTH,
      top: event.y,
      right: event.x,
      bottom: event.y + UtilitRealShapeDrawing.SHAPE_HEIGHT
    };

    shapeRect.left -= UtilitRealShapeDrawing.XY_MOUSE_DISPLACEMENT;
    shapeRect.top += UtilitRealShapeDrawing.XY_MOUSE_DISPLACEMENT;
    shapeRect.right -= UtilitRealShapeDrawing.XY_MOUSE_DISPLACEMENT;
    shapeRect.bottom += UtilitRealShapeDrawing.XY_MOUSE_DISPLACEMENT;

    //console.log('window width: ' + window.innerWidth);
    //console.log('window height: ' + window.innerHeight);
    //console.log('right avant modif: ' + shapeRect.right);
    //console.log('bottom avant modif: ' + shapeRect.bottom);
    if (shapeRect.right > window.innerWidth) {
      const diffWidth = shapeRect.right - window.innerWidth;
      shapeRect.left -= diffWidth;
      shapeRect.right -= diffWidth;
    }
    if (shapeRect.bottom > window.innerHeight) {
      const diffheight = shapeRect.bottom - window.innerHeight;
      shapeRect.top -= diffheight;
      shapeRect.bottom -= diffheight;
    }
    //console.log('right apres modif: ' + shapeRect.right);
    //console.log('bottom apres modif: ' + shapeRect.bottom);
    if (this.mImageRef) {
      this.mImageRef.style.left = shapeRect.left + 'px';
      this.mImageRef.style.top = shapeRect.top + 'px';
      this.mImageRef.width = UtilitRealShapeDrawing.SHAPE_WIDTH;
      this.mImageRef.height = UtilitRealShapeDrawing.SHAPE_HEIGHT;
    }
  }

  public isSameLine(element: CLineDec): boolean {
    return this.mCurrentNoLine === +element.mNoLine;
  }

  public get hasUrl(): boolean {
    if (!this.mImageRef)
      return false;
    return this.mImageRef.src !== undefined && this.mSafeUrlFromServer != null;
  }

  public set imageSrc(image: HTMLImageElement) {
    this.mImageRef = image;
  }

  public set canvasSrc(canvas: HTMLCanvasElement) {
    this.mCanvasRef = canvas;
  }

  public get isImageDisplayed() {
    if (!this.mImageRef)
      return false;
    return this.mImageRef.style.display === 'unsed';
  }

  public get shapeUrl(): SafeUrl | undefined {
    return this.mSafeUrlFromServer;
  }
}

export class FilImportUtilit {

  CST_STATUS_WAITING = 0;
  CST_STATUS_SENDING = 1;

  private mArrayFile: File[] = [];
  private mStatus: number = this.CST_STATUS_WAITING;
  private mLastError: any|undefined = undefined;

  public constructor(private mHttp: HttpClient,
                     private mOrderCode: string) {}

  public async waitToFinish(throwError: boolean): Promise<any> {
    while (this.mArrayFile.length > 0) {
      await CUtilit.sleep(2000);
    }
    if (this.mLastError) {
      // tslint:disable-next-line:no-shadowed-variable
      const error = this.mLastError;
      this.mLastError = undefined;
      throw error;
    }
  }

  public addFile(file: File) {
    this.mArrayFile.push(file);
    if (this.mArrayFile.length === 1)
      this.startNext();
  }

  private startNext() {
    if (this.mArrayFile.length > 0) {
      this.mStatus = this.CST_STATUS_SENDING;
      this.execute(this.mArrayFile[0]);
    } else {
      this.mStatus = this.CST_STATUS_WAITING;
    }
  }

  private async execute(file: File) {
    try {
      const result = await this.loadArrayBuffer(file);
      if (result instanceof ArrayBuffer) {
        const array8b = new Uint8Array(result);
        const arrayStr: any[] = [];
        array8b.forEach(bytes => arrayStr.push(bytes));
        await ArmaServConnection.aPOST(this.mHttp, 'UploadFileForSteelList', arrayStr, [file.name, this.mOrderCode]);
        console.log('import file => OK for ' + file.name + ' - ' + ' order code => ' + this.mOrderCode);
      } else {
        console.error('returned str: ' + result);
      }
    } catch (e) {
      console.error(e);
      this.mLastError = e;
    } finally {
      this.mArrayFile.shift();
      this.startNext();
    }
  }

  private loadArrayBuffer(file: File): Promise<string|ArrayBuffer> {
    return new Promise((resolve) => {
      const reader = new FileReader();
      // @ts-ignore // TODO: TS2345: Argument of type 'string | ArrayBuffer | null' is not assignable to parameter of type 'string | ArrayBuffer | PromiseLike<string | ArrayBuffer> | undefined'.   Type 'null' is not assignable to type 'string | ArrayBuffer | PromiseLike<string | ArrayBuffer> | undefined'.
      reader.onload = () => resolve(reader.result);
      reader.readAsArrayBuffer(file);
    });
  }

  public get status(): number { return this.mStatus; }
  public get isWaiting(): boolean { return this.mStatus == this.CST_STATUS_WAITING; }
}
